export const saveToLocalStorage = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const loadFromLocalStorage = (key, defaultValue) => {
  const savedData = localStorage.getItem(key);
  return savedData ? JSON.parse(savedData) : defaultValue;
};

export const getPointLabels = (formValues) => {
  if (!formValues || !Array.isArray(formValues.positions) || formValues.positions.length < 2) {
    return []; 
  }

  const labels = [];
  const numPoints = formValues.positions.length;

  for (let i = 0; i < numPoints; i++) {
    // Generate label using base-26 logic
    const startLabel = getLabel(i);
    const endLabel = getLabel((i + 1) % numPoints);
    const label = `${startLabel} to ${endLabel}`;
    labels.push(label);
  }
  return labels;
};

// Helper function to convert a number to a base-26 label
const getLabel = (index) => {
  let label = '';
  while (index >= 0) {
    label = String.fromCharCode((index % 26) + 'A'.charCodeAt(0)) + label;
    index = Math.floor(index / 26) - 1; // Adjust for zero-indexing
  }
  return label;
};